<template>
  <b-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
    ></loading>
    <b-row>
      <b-col md="4">
        <b-form-group>
          <b-form-select
            v-model="filter2"
            :options="select.filterOptions"
            required
            class="input-new"
            @change="resetFilter"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-input-group v-if="filter2 === '1'">
          <b-form-input
            v-model="form.name"
            type="text"
            id="filterInput"
            placeholder="Type to Search"
            @click="resetIndex"
            class="input-new"
          ></b-form-input>
        </b-input-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <b-button
            variant="primary"
            class="input-new"
            v-if="filter2 !== null"
            @click="onClickSearch"
            >SEARCH</b-button
          >
          &nbsp;&nbsp;&nbsp;
          <b-button
            variant="warning"
            class="input-new"
            v-if="filter2 !== null"
            @click="clearFilter"
            >CLEAR</b-button
          >
        </b-form-group>
      </b-col>
    </b-row>

    <!-- TABLE -->
    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
      id="my-table"
    >
      <template v-slot:cell(index)="data">
        {{ pagination.startIndex + data.index }}
      </template>
      <template v-slot:cell(type)="data">
        <span v-if="data.value == 1">UHT</span>
        <span v-if="data.value == 2">Pasteurized</span>
      </template>
      <template v-slot:cell(action)="data">
        <span>
          <b-button
            variant="primary"
            size="sm"
            @click="onClickView(data.item.id)"
          >
            VIEW </b-button
          >&nbsp;&nbsp;&nbsp;
          <b-button
            variant="primary"
            size="sm"
            @click="onClickUpdate(data.item.id)"
          >
            UPDATE </b-button
          >&nbsp;&nbsp;&nbsp;
          <b-button
            variant="primary"
            size="sm"
            @click="onClickDelete(data.item.id)"
          >
            DELETE
          </b-button>
        </span>
      </template>
    </b-table>

    <b-row align="right">
      <b-col>
        <b-button variant="primary" size="sm" @click="onClickCreate">
          CREATE
        </b-button>
      </b-col>
    </b-row>

    <b-pagination
      v-if="!isLoading"
      v-model="pagination.current"
      :total-rows="pagination.total"
      :per-page="pagination.perPage"
      @change="onChangePage"
    ></b-pagination>

    <!-- POPUP DELETE -->

    <b-modal id="modal-delete" title="Delete Confirmation">
      <p>
        Are you sure you want to delete ?
      </p>

      <template v-slot:modal-footer="{ close }">
        <b-button variant="primary" size="sm" @click="close()">
          CLOSE
        </b-button>
        <b-button variant="danger" size="sm" @click="onClickDeleteConfirm">
          DELETE
        </b-button>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      filterOn: [],
      totalRows: 1,

      select: {
        filterOptions: [
          { text: "Please Select", value: null },
          { text: "Product Name", value: "1" }
        ]
      },

      items: [],

      filter2: null,

      form: {
        name: null,
        page: 1
      },

      pagination: {
        total: 0,
        current: 1,
        perPage: 10,
        startIndex: 0
      },

      // Loading
      isLoading: false
    };
  },

  components: {
    Loading
  },

  created() {
    if (this.filter) {
      this.filter2 = this.filter !== "null" ? this.filter : null;
      this.pagination.current = this.page !== "null" ? this.page : null;
      this.indexsearch = this.page !== "null" ? this.page : null;
      this.form.name = this.name !== "null" ? this.name : null;

      if (this.filter !== "null") {
        this.onClickSearch();
      } else {
        this.pagination.current = this.page !== "null" ? this.page : null;
        this.getProduct();
      }
    } else {
      this.getProduct();
    }
  },

  props: {
    fields: {
      type: Array,
      required: true
    },

    filter: {
      type: String,
      default: null
    },

    page: {
      type: String
    },

    name: {
      type: String
    }
  },
  methods: {
    onClickCreate() {
      this.$router.push({ path: `createProduct` });
    },
    onClickView(id) {
      this.$router.push({
        path: `viewProduct?id=${id}&filter=${this.filter2}&name=${this.form.name}&page=${this.pagination.current}`
      });
    },
    onClickUpdate(id) {
      this.$router.push({
        path: `updateProduct?id=${id}&filter=${this.filter2}&name=${this.form.name}&page=${this.pagination.current}`
      });
    },
    onClickDelete(id) {
      this.deleteIndex = id;
      this.$bvModal.show("modal-delete");
    },
    onClickDeleteConfirm() {
      const form = {
        product_id: this.deleteIndex
      };
      this.$store.dispatch("deleteProduct", form).then(res => {
        if (res.data.response.code === 1) {
          this.$bvModal.hide("modal-delete");
          this.onClickSearch();
        }
      });
    },

    resetFilter() {
      this.form.name = null;
    },
    clearFilter() {
      this.filter2 = null;
      this.form.name = null;
      this.pagination.current = 1;
      this.getProduct();
    },

    onClickSearch() {
      // let page = this.pagination.current !== this.pagination.startIndex ? this.pagination.startIndex : this.pagination.current
      this.form.page = this.indexsearch;
      if (this.filter2 === null) {
        this.getProduct();
      } else {
        this.isLoading = true;
        this.$store.dispatch("searchProduct", this.form).then(res => {
          this.isLoading = false;
          this.items = [];
          res.data.data.data.forEach(element => {
            this.items.push({
              name: element.name,
              size: element.size,
              type: element.type,
              id: element.product_id
            });
          });

          this.pagination.total = res.data.data.total;
          this.pagination.current = res.data.data.current_page;
          this.pagination.perPage = res.data.data.per_page;
          this.pagination.startIndex = res.data.data.from;
          this.indexsearch = res.data.data.current_page;
        });
      }
    },

    getProduct() {
      //reset array
      this.items = [];
      this.isLoading = true;
      this.$store
        .dispatch("getProductPaginate", this.pagination.current)
        .then(res => {
          this.isLoading = false;
          res.data.data.data.forEach(element => {
            this.items.push({
              name: element.name,
              size: element.size,
              type: element.type,
              id: element.product_id
            });
          });
          this.pagination.total = res.data.data.total;
          this.pagination.current = res.data.data.current_page;
          this.pagination.perPage = res.data.data.per_page;
          this.pagination.startIndex = res.data.data.from;
        });
    },

    resetIndex() {
      this.indexsearch = 1;
    },

    onChangePage(index) {
      this.pagination.current = index;
      if (this.filter2 === null) {
        this.getProduct();
      } else {
        this.indexsearch =
          this.pagination.current !== this.indexsearch
            ? this.pagination.current
            : this.indexsearch++;
        // this.indexsearch++
        this.onClickSearch();
      }
    }
  }
};
</script>
<style lang="css" scoped></style>
